<template>
    <div id="whyus" class="parallax p-0 m-0 h-100"
         v-waypoint="{ active: true, callback: onWaypoint, options: intersectionOptions }">
        <div class="wrapper p-0 m-0 h-100">
            <div class="row justify-content-center">
                <div class="col-12 text-center pt-5">
                    <h1 class="lato-light">Why Join Us?</h1>
                    <p class="lato-light text-center"><b>Earn Big with Bitcoin.com Games Casino!</b></p>
                </div>
            </div>
            <div class="row extra-padding-bottom">
                <div class="col-sm-2 col-1">
                    <img class="img-fluid side-image" src="@/assets/whyus-1.svg">
                </div>
                <div class="col-sm-6 col-10 offset-sm-1 pt-4">
                    <div class="row justify-content-center">
                        <div class="col text-left">
                            <div class="row">
                                <div class="col-1 p-0 m-0 text-right">
                                    <vue-fontawesome icon="check" color="#004750"></vue-fontawesome>
                                </div>
                                <div class="col-11 p-0 m-0 text-left">
                                    <p class="lato-light">
                                        <b>Dedicated Account Management</b> - Experienced Affiliates team<br>
                                    </p>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-1 col-1 p-0 m-0 text-right">
                                    <vue-fontawesome icon="check" color="#004750"></vue-fontawesome>
                                </div>
                                <div class="col-11 p-0 m-0 text-left">
                                    <p class="lato-light">
                                        <b>Tailored Commission Plans</b> - For all types of affiliates<br>
                                    </p>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-1 col-1 p-0 m-0 text-right">
                                    <vue-fontawesome icon="check" color="#004750"></vue-fontawesome>
                                </div>
                                <div class="col-11 p-0 m-0 text-left">
                                    <p class="lato-light">
                                        <b>No Administrative Fees</b><br>
                                    </p>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-1 col-1 p-0 m-0 text-right">
                                    <vue-fontawesome icon="check" color="#004750"></vue-fontawesome>
                                </div>
                                <div class="col-11 p-0 m-0 text-left">
                                    <p class="lato-light">
                                        <b>Unique Affiliates Promotions</b> - Customized to fit the requirements of your network<br>
                                    </p>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-1 col-1 p-0 m-0 text-right">
                                    <vue-fontawesome icon="check" color="#004750"></vue-fontawesome>
                                </div>
                                <div class="col-11 p-0 m-0 text-left">
                                    <p class="lato-light">
                                        <b>No Negative Carryover</b><br>
                                    </p>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-1 col-1 p-0 m-0 text-right">
                                    <vue-fontawesome icon="check" color="#004750"></vue-fontawesome>
                                </div>
                                <div class="col-11 p-0 m-0 text-left">
                                    <p class="lato-light">
                                        <b>Exclusive Bitcoin.com Games</b> - Only available on our Casino<br>
                                    </p>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-1 col-1 p-0 m-0 text-right">
                                    <vue-fontawesome icon="check" color="#004750"></vue-fontawesome>
                                </div>
                                <div class="col-11 p-0 m-0 text-left">
                                    <p class="lato-light">
                                        <b>Wide Variety of Casino Games</b> - Reputed partners (Belatra, BGaming, Ezugi and many more)<br>
                                    </p>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-1 col-1 p-0 m-0 text-right">
                                    <vue-fontawesome icon="check" color="#004750"></vue-fontawesome>
                                </div>
                                <div class="col-11 p-0 m-0 text-left">
                                    <p class="lato-light">
                                        <b>An Immersive Live Casino</b> - Real dealers in a lush environment with a multi-camera setup & various language options<br>
                                    </p>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-1 col-1 p-0 m-0 text-right">
                                    <vue-fontawesome icon="check" color="#004750"></vue-fontawesome>
                                </div>
                                <div class="col-11 p-0 m-0 text-left">
                                    <p class="lato-light">
                                        <b>Provably Fair</b> - All our exclusive games are provably fair<br>
                                    </p>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-1 col-1 p-0 m-0 text-right">
                                    <vue-fontawesome icon="check" color="#004750"></vue-fontawesome>
                                </div>
                                <div class="col-11 p-0 m-0 text-left">
                                    <p class="lato-light">
                                        <b>Anonymous</b> - Play without KYC<br>
                                    </p>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-1 col-1 p-0 m-0 text-right">
                                    <vue-fontawesome icon="check" color="#004750"></vue-fontawesome>
                                </div>
                                <div class="col-11 p-0 m-0 text-left">
                                    <p class="lato-light">
                                        <b>Instant Registrations & Withdrawals</b> - Players don’t have to wait to play & cashout<br>
                                    </p>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-1 col-1 p-0 m-0 text-right">
                                    <vue-fontawesome icon="check" color="#004750"></vue-fontawesome>
                                </div>
                                <div class="col-11 p-0 m-0 text-left">
                                    <p class="lato-light">
                                        <b>24/7 support</b> - You will never walk alone<br>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-2 offset-1">
                    <img class="img-fluid side-image" src="@/assets/whyus-2.svg">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapActions, mapGetters} from "vuex";

    export default {
        name: "WhyUs",
        computed: mapGetters([
            'intersectionOptions'
        ]),
        methods: {
            ...mapActions([
                'setActiveTab',
            ]),
            onWaypoint({ going}) {
                if(going === 'in') {
                    this.setActiveTab('whyus');
                }
            }
        }
    }
</script>

<style scoped>
    .wrapper {
        background-color: #f1f1f1bf;
    }

    .extra-padding-bottom {
        padding-bottom: 50px;
    }

    /*For Desktop/Laptop Display*/
    @media (min-width: 576px) {
        .parallax {
            /* The image used */
            background-image: url('~@/assets/home.png');

            /* Full height */
            height: 100vh;

            /* Create the parallax scrolling effect */
            background-attachment: fixed;
            background-position: center;
            background-repeat: no-repeat;
            background-size: cover;
        }

        h1 {
            font-size: calc(2.5rem + 5vmin) !important;
            color: #004750;
        }

        p {
            font-size: calc(0.4rem + 2vmin) !important;
            color: #004750;
            text-align: justify;
        }
    }
    /*For Mobile Display*/
    @media (max-width: 576px) {
        .side-image {
            display: none;
        }

        h1 {
            font-size: calc(1.5rem + 6vmin) !important;
            color: #004750;
            padding-bottom: 1rem;
        }

        p {
            font-size: calc(0.5rem + 2.7vmin) !important;
            color: #004750;
            text-align: justify;
        }

        .parallax {
            /* The image used */
            background-image: url('~@/assets/home.png');

            /* Full height */
            height: 100%;

            /* Create the parallax scrolling effect */
            background-attachment: fixed;
            background-position: center;
            background-repeat: no-repeat;
            background-size: cover;
        }
    }

    i {
        padding-right: 5px;
    }
</style>